import { usePropertyConstructionStarted } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface ConstructionStartedProps {
    label?: string;
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const ConstructionStarted: React.FC<ConstructionStartedProps> = ({
    label = 'Construction Started? ',
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const [constructionStarted, set_constructionStarted] = usePropertyConstructionStarted(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_constructionStarted(true);
                return;
            case 'no':
                set_constructionStarted(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={constructionStarted ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonConstructionStarted'
                    value={constructionStarted}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Construction Started required.'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
